import { Reducer } from 'redux';

import { IServicesState } from 'types/services.types';
import * as constants from 'redux/constants/services.constants';

export const defaultState: IServicesState = {
  count: 0,
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'name',
    sortType: 'asc',
  },
};

const servicesReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.SERVICES_ON_DELETE_REQUESTED:
    case constants.SERVICES_ON_GET_ALL_REQUESTED:
    case constants.SERVICES_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.SERVICES_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.SERVICES_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.SERVICES_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.SERVICES_ON_DELETE_SUCCEEDED:
    case constants.SERVICES_ON_SAVE_SUCCEEDED:
    case constants.SERVICES_ON_DELETE_FAILED:
    case constants.SERVICES_ON_GET_ALL_FAILED:
    case constants.SERVICES_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.SERVICES_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    default:
      return state;
  }
};

export default servicesReducer;
